

import { useQuery } from "@tanstack/react-query";
import type { SellerOrderDetail } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseStoreOrderByIdQueryParams = {
  storeId: string;
  orderId: string;
};

export function useStoreOrderByIdQuery({
  storeId,
  orderId,
}: UseStoreOrderByIdQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.admin.storeOrderById(storeId, orderId),
    queryFn: () =>
      apiJsonClient<SellerOrderDetail>(endpoints.admin.storeOrderById(storeId, orderId)),
    enabled: storeId.length > 0 && orderId.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
